import { render, staticRenderFns } from "./abnormal.vue?vue&type=template&id=0b45660c&scoped=true"
import script from "./abnormal.vue?vue&type=script&lang=js"
export * from "./abnormal.vue?vue&type=script&lang=js"
import style0 from "./abnormal.vue?vue&type=style&index=0&id=0b45660c&prod&lang=scss"
import style1 from "./abnormal.vue?vue&type=style&index=1&id=0b45660c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45660c",
  null
  
)

export default component.exports